import React, { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { domain, weighingScaleDomain } from "../../security";
import { Plug } from 'lucide-react'; // or 'Link'

export const TermsSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/Terms` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <select
            id="terms"
            className={`mt-1 border rounded-md px-3 py-2 text-sm w-full focus:outline-none focus:ring-1 focus:ring-indigo-500 transition duration-200 bg-white shadow-sm ${
                !isSelected
                ? "border-slate-200 text-slate-400"
                : "border-gray-300 text-gray-700"
                }

                ${!isEditable ? "bg-slate-50 cursor-not-allowed" : ""}
            `}
            value={data}
            onChange={handleSelectChange}
            disabled={!isEditable}
        >
            <option value="">Select Terms</option>
            {_data.map((item) => (
                <option key={item.id} value={item.id}>
                {item.description}
                </option>
            ))}
        </select>
    )
}

export const LocationSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/Locations` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <select
            id="terms"
            className={`mt-1 border rounded-md px-3 py-2 text-sm w-full focus:outline-none focus:ring-1 focus:ring-indigo-500 transition duration-200 bg-white shadow-sm ${
                !isSelected
                ? "border-slate-200 text-slate-400"
                : "border-gray-300 text-gray-700"
            }`}
            value={data}
            onChange={handleSelectChange}
            disabled={!isEditable}
        >
            <option value="">Select Location</option>
            {_data.map((item) => (
                <option key={item.id} value={item.id}>
                {item.locationName}
                </option>
            ))}
        </select>
    )
}

export const PortSelect1 = ({ data, setData, isEditable }) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        const selectedValue = event.target.value;
        // Logic depends on if your API returns strings or objects
        setData(selectedValue);
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${weighingScaleDomain}/api/Scale/ports`, {
                headers: { 'Content-Type': 'application/json' }
            });
            _setData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== "");
    }, [data, fetchData]);

    return (
        <div className="flex w-[100px] mt-1">
            <select
                id="port-select"
                className={`flex-1 border px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-indigo-500 transition duration-200 bg-white shadow-sm
                    rounded-md
                    ${!isSelected ? "border-slate-200 text-gray-400" : "border-gray-300 text-gray-700"}
                `}
                value={data || ""}
                onChange={handleSelectChange}
                disabled={!isEditable}
            >
                <option value="">Select Port</option>
                {_data.map((item, index) => (
                    <option key={index} value={item}>
                        {item}
                    </option>
                ))}
            </select>
        </div>
    );
};
export const PortSelect2 = ({ data, setData, isEditable, onConnect }) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        const selectedValue = event.target.value;
        // Logic depends on if your API returns strings or objects
        setData(selectedValue);
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${weighingScaleDomain}/api/Scale/ports`, {
                headers: { 'Content-Type': 'application/json' }
            });
            _setData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== "");
    }, [data, fetchData]);

    return (
        <div className="flex w-[100px] mt-1">
            <select
                id="port-select"
                className={`flex-1 border px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-indigo-500 transition duration-200 bg-white shadow-sm
                    rounded-l-md rounded-r-none 
                    border-r-0
                    ${!isSelected ? "border-slate-200 text-gray-400" : "border-gray-300 text-gray-700"}
                `}
                value={data || ""}
                onChange={handleSelectChange}
                disabled={!isEditable}
            >
                <option value="">Select Port</option>
                {_data.map((item, index) => (
                    <option key={index} value={item}>
                        {item}
                    </option>
                ))}
            </select>

            <button
                type="button"
                onClick={onConnect}
                title="Connect Scale"
                disabled={!isEditable || !data}
                className={`px-2 py-1 flex items-center justify-center border flex-shrink-0 transition-colors
                    rounded-r-md rounded-l-none
                    ${!data || !isEditable 
                        ? "bg-gray-50 text-gray-300 border-gray-200 cursor-not-allowed" 
                        : "bg-indigo-600 text-white border-indigo-600 hover:bg-indigo-700 shadow-sm"
                    }
                `}
            >
                <Plug size={18} />
            </button>
        </div>
    );
};

export const BrandSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/Brands` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <select
            id="terms"
            className={`mt-1 border rounded-md px-3 py-2 text-sm w-full focus:outline-none focus:ring-1 focus:ring-indigo-500 transition duration-200 bg-gray-50 border-gray-300 shadow-sm ${
                !isSelected
                ? "border-slate-200 text-slate-400"
                : "border-gray-300 text-gray-700"
                }

                ${!isEditable ? "bg-slate-50 cursor-not-allowed" : ""}
            `}
            value={data?.id || ""}
            onChange={handleSelectChange}
            disabled={!isEditable}
        >
            <option value="">Select Brand</option>
            {_data.map((item) => (
                <option key={item.id} value={item.id}>
                {item.brandName}
                </option>
            ))}
        </select>
    )
}
export const CategorySelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/Categories` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <select
            id="terms"
            className={`mt-1 border rounded-md px-3 py-2 text-sm w-full focus:outline-none focus:ring-1 focus:ring-indigo-500 transition duration-200 bg-gray-50 border-gray-300 shadow-sm ${
                !isSelected
                ? "border-slate-200 text-slate-400"
                : "border-gray-300 text-gray-700"
                }

                ${!isEditable ? "bg-slate-50 cursor-not-allowed" : ""}
            `}
            value={data?.id || ""}
            onChange={handleSelectChange}
            disabled={!isEditable}
        >
            <option value="">Select Category</option>
            {_data.map((item) => (
                <option key={item.id} value={item.id}>
                {item.categoryName}
                </option>
            ))}
        </select>
    )
}

export const BrandSelectBlack = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/Brands` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <select
            id="terms"
            className={`mt-1 border rounded-md text-sm w-full focus:outline-none focus:ring-1 focus:ring-indigo-500 transition duration-200 p-3 text-white bg-slate-700 border-slate-600 shadow-sm ${
                !isSelected
                ? ""
                : ""
                }

                ${!isEditable ? "bg-slate-50 cursor-not-allowed" : ""}
            `}
            value={data?.id || ""}
            onChange={handleSelectChange}
            disabled={!isEditable}
        >
            <option value="">Select Brand</option>
            {_data.map((item) => (
                <option key={item.id} value={item.id}>
                {item.brandName}
                </option>
            ))}
        </select>
    )
}
export const CategorySelectBlack = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/Categories` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <select
            id="terms"
            className={`mt-1 border rounded-md text-sm w-full focus:outline-none focus:ring-1 focus:ring-indigo-500 transition duration-200 p-3 text-white bg-slate-700 border-slate-600 shadow-sm ${
                !isSelected
                ? ""
                : ""
                }

                ${!isEditable ? "bg-slate-50 cursor-not-allowed" : ""}
            `}
            value={data?.id || ""}
            onChange={handleSelectChange}
            disabled={!isEditable}
        >
            <option value="">Select Category</option>
            {_data.map((item) => (
                <option key={item.id} value={item.id}>
                {item.categoryName}
                </option>
            ))}
        </select>
    )
}

export const TripTicketNumberSeriesSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/TripTicketNumberSeries/active` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    console.log({_data})

    return (
        <select
            id="terms"
            className={`block w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-white outline-none transition focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400 ${
                !isSelected
                ? "border-slate-200 text-slate-400"
                : "border-gray-300 text-gray-700"
                }

                ${!isEditable ? "bg-slate-50 cursor-not-allowed" : ""}
            `}
            value={data?.id}
            onChange={handleSelectChange}
            disabled={!isEditable}
        >
            <option value="">Select Trip Ticket</option>
            {_data.map((item) => (
                <option key={item.id} value={item.id}>
                {`${item.seriesName}`}
                </option>
            ))}
        </select>
    )
}